import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ScriptPreferencesDialogComponent } from '@pages/checkout-app/checkout-layout/main/components/settings/components/dialogs/script-preferences-dialog.component';
import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';
import { first } from 'rxjs/operators';

@Component({
  selector: 'plugins-script-preferences',
  templateUrl: './plugins-script-preferences.html',
  styleUrls: ['./plugins-script-preferences.scss'],
  standalone: false,
})
export class PluginsScriptPreferencesComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() shop: Shop;
  @Input() settings: CheckoutSettings;
  innerHtmlText = `Enabling custom scripts is an advanced action and should be taken with care.
     Consult your development team as needed to ensure proper configuration with your shop’s codebase. Read more about it in
    <pdq-link
        external="true"
        label="support center"
        url="https://support.prettydamnquick.com/en/articles/8560867-adding-multiple-pdq-components"></pdq-link>.`;
  constructor(private dialog: MatDialog) {}

  handleToggle(event: boolean | null): void {
    if (event || event === null) {
      const dialogRef = this.dialog.open(ScriptPreferencesDialogComponent, {
        autoFocus: false,
      });

      dialogRef
        .afterClosed()
        .pipe(first())
        .subscribe((result) => {
          this.formGroup.patchValue({ pluginsScriptTagEnabled: !!result });
          this.formGroup.markAsDirty();
        });
    }
  }
}
